import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function PrivateRoute({ children, allowedRoles = [] }) {
  const token = localStorage.getItem('token');
  let user = {};
  try { user = JSON.parse(localStorage.getItem('user') || '{}'); } catch { user = {}; }
  const location = useLocation();

  // Not authenticated at all
  if (!token || !user.role) {
    
    // Determine which login page based on the path
    if (location.pathname.startsWith('/photographer')) {
      return <Navigate to="/photographer/login" replace />;
    } else if (location.pathname.startsWith('/client')) {
      return <Navigate to="/client/login" replace />;
    } else {
      return <Navigate to="/admin/login" replace />;
    }
  }

  // If specific roles are required, check them
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on actual role
    if (user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    } else if (user.role === 'photographer') {
      return <Navigate to="/photographer" replace />;
    } else if (user.role === 'client') {
      return <Navigate to="/client/portal" replace />;
    }
    
    return <Navigate to="/" replace />;
  }

  /**
   * Wrap authenticated portal screens in a container the theme can target.
   *
   * Dark mode is opt-in PER MIGRATED CONTAINER — never on `body` or `:root`,
   * because that leaks to the public marketing site (it did, on 2026-07-26).
   * Admin pages had no common wrapper class, so this supplies one at the route
   * boundary rather than editing 20 page components. Only authenticated
   * portal screens pass through here, so the public site can never inherit it.
   */
  const portal = location.pathname.startsWith('/admin')
    ? 'admin-portal'
    : location.pathname.startsWith('/photographer')
      ? 'photographer-portal'
      : location.pathname.startsWith('/client')
        ? 'client-portal-shell'
        : null;

  return portal ? <div className={portal}>{children}</div> : children;
}

export default PrivateRoute;
